var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BonusCode"},[_c('BasiceLayout',{staticClass:"bonus-code-layout revenue-all-layout",attrs:{"title":_vm.$t('revenue_data_text')}},[_c('RevenueContent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }